import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const Indicators = () => {
    const { chartData } = useResultsChartsDataContext();

    return (
        <div className="w-100">
            <Card
                title="Tempo Médio de Emissão de Atestado de Óbito (em dias)"
                value={number.formatToBRNumber(
                    chartData?.indicators?.averageDeathCertificateTime || 0
                )}
            />
        </div>
    );
};
